/**
 * @desc
 * Initial route is the route that the user visit.
 * This function will attempt to learn which route the user used to visit
 * and stored it to local storage for redirection later
 * @param router
 * @param forceLearn
 * @param avoidLearnList
 */
function rememberInitialRoute (router, forceLearn = false, avoidLearnList = ['ManageAccount', 'Home']) {
  const name = router.name ? router.name : router.currentRoute.name
  const fullPath = router.fullPath ? router.fullPath : router.currentRoute.fullPath
  if (!avoidLearnList.includes(name)) {
    const alreadyStoredOnce = window.sessionStorage.getItem('already_stored_initial_route')
    if(forceLearn) {
      window.sessionStorage.setItem('initial_route', fullPath)
      window.sessionStorage.setItem('already_stored_initial_route', 'true')
    } else if (alreadyStoredOnce !== 'true') {
      window.sessionStorage.setItem('initial_route', fullPath)
      window.sessionStorage.setItem('already_stored_initial_route', 'true')
    }
  }
}

/**
 * @desc to clear local storage items that is used to assist in route redirection
 */
function clear () {
  window.sessionStorage.removeItem('initial_route')
  window.sessionStorage.removeItem('already_stored_initial_route')
}

/**
 * @desc to route user back to the initial URL that the user used to visit the app
 * If there is no initial route, the router will push to fallBack route
 * @param router
 * @param fallBack
 */
function redirectToInitialRoute (router, fallBack) {
  const initialRoute = window.sessionStorage.getItem('initial_route')
  if (initialRoute) {
    if(router.currentRoute.fullPath !== initialRoute) {
      router.push(initialRoute)
        .catch(error => {
          console.warn(error)
        }).finally(() => {
          clear()
        })
    }
  } else {
    router.push(fallBack)
  }
}

export default {
  rememberInitialRoute, redirectToInitialRoute, clear
}
